export const theme = {
  colors: {
    primary: '#FF6B00',
    secondary: '#FF8A00',
    accent: '#FFA500',
    text: '#FFFFFF',
    textLight: 'rgba(255, 255, 255, 0.8)',
    background: '#1A1A1A',
    backgroundLight: '#2C2C2C',
    border: 'rgba(255, 107, 0, 0.1)',
    white: '#FFFFFF',
    black: '#1A1A1A',
    overlay: 'rgba(26, 26, 26, 0.8)'
  },
  gradients: {
    primary: 'linear-gradient(135deg, #FF6B00 0%, #FF8A00 100%)',
    background: 'linear-gradient(145deg, #2C2C2C 0%, #1A1A1A 100%)',
    subtle: `
      radial-gradient(70% 50% at 50% 0%, rgba(255, 107, 0, 0.05) 0%, transparent 100%),
      radial-gradient(50% 80% at 20% 100%, rgba(255, 107, 0, 0.05) 0%, transparent 100%)
    `
  },
  shadows: {
    small: `
      0 8px 20px rgba(255, 107, 0, 0.15),
      0 2px 4px rgba(255, 107, 0, 0.1)
    `,
    medium: `
      0 20px 40px rgba(255, 107, 0, 0.2),
      0 4px 8px rgba(255, 107, 0, 0.15)
    `,
    large: `
      0 30px 60px rgba(255, 107, 0, 0.25),
      0 6px 12px rgba(255, 107, 0, 0.2)
    `,
    glow: '0 0 20px rgba(255, 107, 0, 0.3)'
  },
  transitions: {
    default: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
    smooth: 'all 0.4s cubic-bezier(0.22, 1, 0.36, 1)',
    bounce: 'all 0.5s cubic-bezier(0.68, -0.6, 0.32, 1.6)'
  },
  borderRadius: {
    small: '8px',
    medium: '16px',
    large: '24px',
    circle: '50%'
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    heading: {
      h1: 'clamp(2.5rem, 5vw, 4rem)',
      h2: 'clamp(2rem, 4vw, 3rem)',
      h3: 'clamp(1.5rem, 3vw, 2rem)',
      h4: 'clamp(1.2rem, 2vw, 1.5rem)'
    },
    body: {
      large: 'clamp(1.2rem, 2vw, 1.4rem)',
      regular: '1rem',
      small: '0.875rem'
    },
    weight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      black: 900
    }
  },
  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem',
    xxl: '6rem'
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1400px'
  }
}; 